import './PromissoryNoteGroup.scss';
import './PromissoryNoteIndividual.scss';
import React from 'react';
import RequisitionModel from '../../../models/RequisitionModel';
import formatString from '../../../utilities/format-string';
import Signature from '../components/Signature';
import PromissoryNoteTemplate from './components/PromissoryNoteTemplate';
import SignaturePlaceDate from '../components/SignaturePlaceDate';

const PromissoryNoteIndividual = ({ client, requisition, guarantor }) => {
  const borrowerName = `${client.nombre} ${client.apellido_paterno} ${client.apellido_materno}`;

  const total = RequisitionModel.getTotalAmountByType(
    'monto_autorizado',
    requisition?.montos.filter(
      (payment) => payment.Socio.objectId === client.objectId
    )
  );

  const formattedTotal = formatString.setLegiblePrice(total);

  const totalLetter = formatString.convertNumbersToLetters(total);

  const totalAmmout = `${formattedTotal} (${totalLetter} 00/100 M.N.)`;

  const address = `${requisition?.Sucursal.direccion}, ${requisition?.Sucursal.nombre}, ${requisition?.Sucursal.entidad_federativa}`;

  const date = formatString.setLegibleDatePlainText(
    requisition.fecha_elaboracion.iso
  );

  const isSinglePromissory =
    requisition?.Grupo?.Socios?.length === 1 ? true : false;

  return (
    <div
      className={`document-promissory-note ${
        isSinglePromissory ? '' : 'document-promissory-note-individual'
      }`}
    >
      <PromissoryNoteTemplate
        totalAmount={totalAmmout}
        isGroup={false}
        borrowerName={borrowerName}
        address={address}
        sex={client.sexo}
      />

      <p>ACEPTO PAGAR A SU VENCIMIENTO EN FORMA SOLIDARIA:</p>

      <div>
        <Signature
          socio={client}
          guarantor={guarantor}
          isTwoColumn={!isSinglePromissory}
        />
      </div>

      <div style={{ marginTop: isSinglePromissory ? '6em' : '1em' }} />

      <SignaturePlaceDate date={date} address={address} />
    </div>
  );
};

export default PromissoryNoteIndividual;
